import { render, staticRenderFns } from "./OtherRegister.vue?vue&type=template&id=0bdacd7d&scoped=true"
import script from "./OtherRegister.vue?vue&type=script&lang=js"
export * from "./OtherRegister.vue?vue&type=script&lang=js"
import style0 from "./OtherRegister.vue?vue&type=style&index=0&id=0bdacd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdacd7d",
  null
  
)

export default component.exports